import { AfterViewInit, Component, NgZone, OnInit } from '@angular/core';
import { App as CapacitorApp, URLOpenListenerEvent } from '@capacitor/app';
import { NetworkService } from './services/network.service';
import { Capacitor } from '@capacitor/core';
import { JailbreakRoot } from '@basecom-gmbh/capacitor-jailbreak-root-detection';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { PushNotifService } from './services/push-notif.service';
import { EnvService } from './services/env.service';
import { AppUpdateService } from './services/app-update.service';
import { NbDialogService } from '@nebular/theme';
import { TextZoom } from '@capacitor/text-zoom';
import { TextzoomService } from './services/textzoom.service';
import MockDetector from './plugins/mock-detector';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  constructor(
    private networkService: NetworkService,
    private notifService: PushNotifService,
    private envService: EnvService,
    private appUpdateService: AppUpdateService,
    private dialogService: NbDialogService,
    private textZoomService: TextzoomService,
    private pushNotif: PushNotifService,
    private zone: NgZone,
    private router: Router,
    private oauthService: OAuthService,
  ) {}

  ngOnInit(): void {
    CapacitorApp.addListener('backButton', () => {
      CapacitorApp.exitApp();
    });
    this.initialize();
    this.setupAppListener();
  }

  async initialize() {
    this.networkService.initNeworkStatus();

    if (Capacitor.isNativePlatform()) {
      SplashScreen.hide();
      this.setStatusbar();
      this.pushNotif.initPushNotif();
      let currentZoomLevel = this.textZoomService.appPreferredSizeValue;
      if (Capacitor.getPlatform() === 'android') {
        this.detectJailbreakRoot();
      }
      if (currentZoomLevel) {
        this.textZoomService.setZoom(currentZoomLevel);
      } else {
        this.textZoomService.setZoom((await TextZoom.getPreferred()).value);
      }
    }

    this.checkSsoSession();
  }

  async checkSsoSession() {
    try {
      await this.oauthService.loadDiscoveryDocumentAndTryLogin();

      if (this.oauthService.hasValidAccessToken()) {
        this.oauthService.setupAutomaticSilentRefresh();
        this.router.navigate(['/app'], { replaceUrl: true });
        return;
      }

      if (!Capacitor.isNativePlatform()) {
        await this.oauthService.silentRefresh();
        if (this.oauthService.hasValidAccessToken()) {
          this.oauthService.setupAutomaticSilentRefresh();
          this.router.navigate(['/app'], { replaceUrl: true });
        }
      }
    } catch (error) {
      console.log('Sesi SSO tidak ditemukan, abaikan ke rute default.');
    }
  }

  detectJailbreakRoot() {
    JailbreakRoot.isJailbrokenOrRooted().then((res) => {
      if (res.result) {
        alert('We detected that your device is jailbroken or rooted');
        CapacitorApp.exitApp();
      }
      return;
    });
  }

  async setStatusbar() {
    const setToLight = await StatusBar.setStyle({ style: Style.Light });
  }

  private setupAppListener() {
    CapacitorApp.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        const url = event.url;

        if (url.includes('com.badungkab.sikapbadung://auth/callback')) {
          const params = url.split(
            'com.badungkab.sikapbadung://auth/callback',
          )[1];
          this.router.navigateByUrl('/auth/callback' + params);
        }
      });
    });
  }
}
